module.exports = "/* Header */\n#collections-container-about {\n  height: 100vh;\n  overflow: hidden;\n  background-image: url(\"/assets/img/quienessomos.jpg\");\n  background-size: cover; }\n#collections-container-about__item {\n    cursor: pointer; }\n#collections-container-about__item img {\n      max-height: 70vh;\n      max-width: 340px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/about/about.component.scss
// module id = ./src/app/about/about.component.scss
// module chunks = main